import { generateKeyBetween } from 'fractional-indexing'

function boundsAreInvalid(before, after) {
  if (before == null || after == null) return false
  return before >= after
}

/**
 * generateKeyBetween throws when bounds collide or invert (e.g. duplicate sort_key).
 * CODEX-READER-13: "a1V >= a1V"
 */
export function safeGenerateKeyBetween(before, after) {
  if (boundsAreInvalid(before, after)) {
    return generateKeyBetween(before, null)
  }
  try {
    return generateKeyBetween(before, after)
  } catch {
    return generateKeyBetween(before, null)
  }
}

/** Re-key sections that share or invert sort_key so fractional inserts stay valid. */
export function normalizeSectionSortKeys(sections) {
  if (!sections?.length) return sections ?? []

  const sorted = [...sections].sort((a, b) => {
    const ak = a.sort_key ?? ''
    const bk = b.sort_key ?? ''
    if (ak === bk) return 0
    return ak < bk ? -1 : 1
  })

  let prev = null
  return sorted.map((section) => {
    let key = section.sort_key ?? null
    if (!key || (prev != null && key <= prev)) {
      key = safeGenerateKeyBetween(prev, null)
    }
    prev = key
    return { ...section, sort_key: key }
  })
}
